import {
  createReactRouterV7Options,
  getWebInstrumentations,
  initializeFaro,
  ReactIntegration
} from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import {
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType
} from 'react-router';

const isLive = "Live" === 'Live';

const apiBaseUrl = isLive
  ? "https://api.zapkart.com"
  : "https://ecommerceapi.riolabz.com";

initializeFaro({
  url: `${apiBaseUrl}/api/v1/telemetry/faro`,
  batching: {
    enabled: true,
    sendTimeout: 20000,
    itemLimit: 50
  },
  app: {
    name: 'zapkart-customer',
    version: '1.0.0',
    environment: 'production'
  },
  instrumentations: [
    ...getWebInstrumentations(),
    new TracingInstrumentation(),
    new ReactIntegration({
      router: createReactRouterV7Options({
        createRoutesFromChildren,
        matchRoutes,
        Routes,
        useLocation,
        useNavigationType
      })
    })
  ]
});
